module.exports = __webpack_public_path__ + "img/635.85c09bbe.jpg";